import React, { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Navbar from "./pages/Navbar/Navbar";
import MainRoutes from "./pages/Route/route";
import Footer from "./pages/Footer/Footer";
import "../src/App.css";
import Loader from "./Components/Loader/Loader";
import { CartProvider } from "./context/CartContext";
import { NavbarProvider, useNavbar } from "./context/NavbarContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  function AppLayout() {
    const { isNavbarVisible } = useNavbar();
    const location = useLocation();
    const hideNavbarByPath = location.pathname.startsWith("/reset-password") || location.pathname === "/terms-and-conditions" || location.pathname === "/privacy-policy";
    
    return (
      <>
        {isNavbarVisible && !hideNavbarByPath && <Navbar />}
        <ToastContainer position="top-right" autoClose={5000} />
        <MainRoutes />
      </>
    );
  }

  return (
    <CartProvider>
      <NavbarProvider>
        <BrowserRouter>
          <AppLayout />
          {/* <Footer /> */}
        </BrowserRouter>
      </NavbarProvider>
    </CartProvider>
  );
}

export default App;
